import {
  MAX_MAX_TOKENS,
  MIN_MAX_TOKENS,
} from "@/lib/ai/settings-parse";

export const aiSettingsCopy = {
  title: "AI",
  description:
    "Лимит ответа, ожидание Wiki и квоты сотрудников. Модели задаёт платформа.",
  errorTitle: "Настройки AI",
  savedTitle: "Сохранено",
  saved: "Настройки сохранены.",
  save: "Сохранить",
  pending: "Сохраняем…",
  tabModel: "Модель",
  tabGeneration: "Генерация",
  tabWiki: "Wiki",
  providerTitle: "Провайдер",
  providerHelp:
    "Кто отвечает в чате. Поиск по смыслу документов по-прежнему идёт через Ollama.",
  providerLegend: "Провайдер чата",
  ollama: "Ollama",
  openrouter: "OpenRouter",
  timeweb: "Timeweb",
  ollamaTitle: "Ollama",
  ollamaUrl: "Адрес Ollama",
  chatModel: "Модель чата",
  keysTitle: "Ключи",
  keyTitle: "Ключ OpenRouter",
  keyLabel: "Ключ OpenRouter",
  keySaved: "Ключ сохранён. Оставьте пустым, чтобы не менять.",
  keyHint: "Ключ с openrouter.ai. В интерфейс не возвращается.",
  timewebKeyTitle: "Ключ Timeweb",
  timewebKeyLabel: "Ключ Timeweb AI Gateway",
  timewebKeyHint: "Ключ из AI Gateway timeweb.cloud. В интерфейс не возвращается.",
  timewebAccountKeyLabel: "Токен аккаунта Timeweb Cloud",
  timewebAccountKeyHint:
    "Нужен для цен в каталоге и учёта расхода в ₽. Это не ключ Gateway. В интерфейс не возвращается.",
  catalogTitle: "Модель",
  catalogLabel: "Каталог моделей",
  catalogPlaceholder: "Название или id",
  catalogLoading: "Загружаем каталог…",
  catalogFailed: "Не удалось загрузить каталог.",
  catalogNeedsKey: "Введите ключ — список моделей появится сам.",
  catalogNoRates:
    "Список моделей есть, но цены не загрузились. Расход в ₽ считаться не будет.",
  catalogEmpty: "Нет моделей по этому фильтру.",
  catalogSelected: "Выбрана",
  timewebReasoningHelp:
    "Timeweb Chat Completions пока без размышления в запросе.",
  answerTitle: "Длина ответа",
  maxTokens: "Лимит ответа",
  maxTokensHelp: "Сколько текста модель может сгенерировать. Для размышления лучше 4096 и выше.",
  reasoningTitle: "Размышление",
  reasoningLegend: "Размышление",
  reasoningOn: "Вкл",
  reasoningOff: "Выкл",
  reasoningHelp:
    "Выключено — сразу ответ. Включённое размышление может съесть лимит и оставить пустой ответ.",
  reasoningLocked:
    "Всегда включено: эта модель не умеет отвечать без размышления.",
  wikiTitle: "Извлечение фактов",
  wikiHelp:
    "Модель можно выбрать отдельно от чата. Факты читаются пакетами фрагментов. Ошибка извлечения не ломает разбор документа.",
  extractModel: "Модель извлечения",
  extractModelHelp: "Пусто — та же модель, что в чате.",
  extractModelSame: "Как в чате",
  extractModelUsingChat: "Сейчас как в чате. Выберите строку в каталоге, чтобы заменить.",
  timeoutTitle: "Ожидание",
  timeoutLabel: "Таймаут, секунды",
  timeoutHelp: "Сколько ждать ответ модели на один запрос. От 30 до 600.",
  extractReasoningTitle: "Размышление при извлечении",
  extractReasoningLegend: "Размышление при извлечении",
  extractReasoningHelp:
    "Для фактов обычно выключено — иначе модель часто не укладывается в ожидание.",
  quotaTitle: "Лимит сотрудника",
  quotaLabel: "Лимит, $ / месяц",
  quotaLabelRub: "Лимит, ₽ / месяц",
  quotaHelp:
    "Сколько может потратить один сотрудник за календарный месяц в каждой валюте. Пусто — без лимита. $ и ₽ не складываются.",
} as const;

export function aiMaxTokensError(): string {
  return `Лимит ответа: целое число от ${MIN_MAX_TOKENS} до ${MAX_MAX_TOKENS}`;
}

export function aiQuotaError(): string {
  return "Лимит: число от 0 до 100000, не больше двух знаков после точки.";
}
